import "./Hero.scss";
import { useState } from "react";
import Search from "../Search/Search";
import Button from "../Button/Button";

const Hero = ({
  timeInterval,
  setTimeInterval,
  setSearchTerm,
  analysis,
  postsAnalyzed,
  setPostsAnalyzed,
  subreddits,
}) => {
  const [subredditSearch, setSubredditSearch] = useState(true);

  const toggleSearch = () => {
    setSubredditSearch(!subredditSearch);
  };

  return (
    <section className="hero">
      <div className="hero__overlay">
        <h1 className="hero__header">
          {subredditSearch
            ? "Find the best time to post your content."
            : "Discover subreddits discussing your keyword."}
        </h1>
        <Search
          analysis={analysis}
          timeInterval={timeInterval}
          setTimeInterval={setTimeInterval}
          setSearchTerm={setSearchTerm}
          postsAnalyzed={postsAnalyzed}
          setPostsAnalyzed={setPostsAnalyzed}
          subreddits={subreddits}
          subredditSearch={subredditSearch}
        />
        <Button
          label={
            subredditSearch
              ? "Search for keywords instead"
              : "Search for subreddits instead"
          }
          type="switch"
          action={toggleSearch}
        />
      </div>
    </section>
  );
};

export default Hero;
